<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('navigation.signup') }}</h4>
        </dialog-header>

        <div class="ngdialog__body">
            <p v-html="$t('registration.signup_welcome')"></p>
        </div>
        <user-form
            v-on:send="sendForm"
            v-bind:showTerms="true"
            v-bind:showPassword="true"
            class="form--signupform"
            ref="userform"
        ></user-form>
        <div class="ngdialog__button-group">
            <div class="ngdialog__button-group__item">
                <a
                    class="ngdialog__button ngdialog__button--secondary"
                    @click="$emit('close')"
                    same-height="dialog-button"
                >
                    <span class="ngdialog__button__text">{{ $t('buttons.cancel') }}</span>
                </a>
            </div>

            <div class="ngdialog__button-group__item">
                <button
                    type="submit"
                    class="ngdialog__button"
                    @click.prevent="sendForm"
                    same-height="dialog-button"
                >
                    <span class="ngdialog__button__text">{{ $t('registration.signup') }}</span>
                    <i
                        class="icon icon--common-spinner spinner"
                        :class="{ 'spinner--finished': !loading }"
                    ></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import UserForm from '@/components/UserForm';
import DialogHeader from '@/components/DialogHeader';

export default {
    components: {
        UserForm,
        DialogHeader,
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        sendForm() {

            if(!/[0-9]/.test(this.$refs.userform.user.password) || !/[a-z]/.test(this.$refs.userform.user.password) || !/[A-Z]/.test(this.$refs.userform.user.password) || !/[^0-9a-zA-Z ]/.test(this.$refs.userform.user.password) || this.$refs.userform.user.password.length < 12 || this.$refs.userform.user.password !== this.$refs.userform.user.passwordRepeat){
                //console.log('password requirements not met')
                return;
            }

            if(this.loading) return

            if (this.$refs.userform.$v.$invalid) {
                this.$refs.userform.$v.$touch();
                return;
            }

            this.loading = true

            api.users.register({ user: this.$refs.userform.user }).then(
                () => {
                    this.$route.meta.finalizedSignup = true;
                    this.loading = false
                    this.$store
                        .dispatch('login', {
                            email: this.$refs.userform.user.email,
                            password: this.$refs.userform.user.password,
                        })
                        .then(
                            () => {
                                this.$modal.hide('Signup');
                            },
                            error => {
                                this.$refs.userform.loginError = error.response.status;
                            }
                        );
                },
                error => {
                    this.loading = false
                    this.$refs.userform.remoteErrorMessage = error.response.data.errors.email[0];
                }
            );
        },
    },
};
</script>
